<div class="mydocma-mm-task-dashboard">
<mydocma-task-dashboard #daskboard  (closeClick)="onCloseClick()"></mydocma-task-dashboard>
<div class="mobile-pane-footer" *ngIf="(appContainerService.mobileView$ | async)">
  <div style="margin-right: 10px">
    <button mat-stroked-button (click)="onCloseClick()" class="mydocma-btn-primary">
      Ok
    </button>
  </div>
</div>
<div>
